import React from 'react';
import { useOfferContext } from '../../../../context';
import { FeatureLabels } from '../../../../components/FeatureLabels';
import { VideoLabelContainer } from '../VideoLabelContainer';
import { TourLabelContainer } from '../TourLabelContainer';

export function FeatureLabelsContainer() {
  const { hasVideo, hasTour } = useOfferContext();

  if (!hasVideo && !hasTour) {
    return null;
  }

  return (
    <FeatureLabels>
      <VideoLabelContainer />
      <TourLabelContainer />
    </FeatureLabels>
  );
}
